import StepBaseService from "../stepBase";
import StepBusinessType from "../stepBase/stepBusinessType";

class ProcedureFileStepService extends StepBaseService {
  // @ts-ignore
  getProcedureFileStepKey = () => {
    return {
      dataKey: StepBusinessType.procedureFile.dataKey,
      settingKey: "getProcedureFolderStepItem",
    };
  };

  // @ts-ignore
  getTaskInfoKey = () => {
    return StepBusinessType.taskInfo;
  };

  // @ts-ignore
  getFlowStepData = () => null;
}

export default new ProcedureFileStepService();
